import {
  Link,
  sidebarConfig,
  useSidebarOpenState,
} from '@backstage/core-components';
import { makeStyles } from '@material-ui/core';
import { LogoFull } from './LogoFull';
import { LogoIcon } from './LogoIcon';

// Collapsed, the 28px icon is centred on the nav icons (36px from the edge);
// expanded, the wordmark's left edge lines up with them at 28px.
const useSidebarLogoStyles = makeStyles({
  root: {
    width: sidebarConfig.drawerWidthClosed,
    height: 3 * sidebarConfig.logoHeight,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    marginBottom: -14,
  },
  link: {
    width: sidebarConfig.drawerWidthClosed,
    marginLeft: ({ isOpen }: { isOpen: boolean }) => (isOpen ? 28 : 22),
  },
});

export const SidebarLogo = () => {
  const { isOpen } = useSidebarOpenState();
  const classes = useSidebarLogoStyles({ isOpen });

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Home">
        {isOpen ? <LogoFull /> : <LogoIcon />}
      </Link>
    </div>
  );
};
